// this file is automatically generated by git.revision.js script
export const versions = { revision: '8899a63357' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '8899a63357';
